<template>
  <div class="control-parent">
        <div class="timings">
            <span>{{displayTime}}</span>
            <span>{{displayDuration}}</span> 
        </div>
      <div class="progress-wrapper">
            <slide-bar class="progress-slider" 
            :progress="progress"
            hover-effects
            @progresschange='getPosition'
            @seekchange="getSeek"
            @mousehover="showHover"
            :buffer-start='bufferedPeriod[0]'
            :buffer-end='bufferedPeriod[1]'
            ref="progressBar"
            :progress-color="settings.slidebar.progressColor"
            :pointer-color="settings.slidebar.pointerColor"
             ></slide-bar>
             <div :style="{left:`${seekPoint}%`}" class="seeker">{{displaySeek}}</div>
      </div>
      <div class="controls">
          <div class="left">
                <div class="volume-wrapper">
                    <img :src="videoController.muted?volumeDisabledIcon:volumeActiveIcon" @click="videoController.toggleMute()" alt="volume" class="volume-icon">
                    <slide-bar class="volume-slider" 
                    :progress="videoController.muted?0:volume" 
                    @progresschange="updateVolume" 
                    :progress-color="settings.slidebar.progressColor"
                    :pointer-color="settings.slidebar.pointerColor"
                    ></slide-bar>
                </div>
          </div>
          <div class="right">
              <div class="minimise-wrapper" id="player-minimiser-feature">
                  <button type="button" class="minimise-button" @click="toggleMinimise(true)">
                      <img :src="minimiseIcon" alt="minimise" class="m-icon" />
                  </button>
              </div>
              <div class="settings-wrapper" v-if="settingsAvailable">
                  <button type="button" class="settings-button" @click="settingsToggle()">
                      <img :src="settingIcon" alt="settings" class="st-icon" />
                  </button>
              </div>
              <div class="playlist-wrapper">
                  <button type="button" class="playlist-button" @click="playlistToggle()">
                      <img :src="playlistIcon" alt="playlist" class="pl-icon" />
                  </button>
              </div>
              <div class="fs-wrapper" v-if="fsEnabled">
                  <button type="button" @click='fsToggle'>
                    <img :src="fsIcon" alt="fullscreen" class="fs-icon" />
                  </button>
              </div>
          </div>
      </div>
     
  </div>
</template>

<script>
import {getDuration} from '@video/src/mixins/supports';
export default {
    props:[
        'currentTime',
        'contentDuration',
        'videoController',
        'bufferedRange',
        'fsToggle',
        'fsActive',
        'playlistToggle',
        'settingsToggle',
        'toggleMinimise',
        'settings',
        'contentPlaying',
        'live',
        'ended',
        'settingsAvailable'
        ],
    data(){
        return {
            seekActive:false,
            progressTime:0,
            displaySeek:'00:00',
            seekPoint:0,
            volumeActiveIcon:require('@video/src/assets/volume_enabled.svg'),
            volumeDisabledIcon:require('@video/src/assets/volume_disabled.svg'),
            fullscreenEnterIcon:require('@video/src/assets/fullscreen_enter.svg'),
            fullscreenExitIcon:require('@video/src/assets/fullscreen_exit.svg'),
            playlistIcon:require('@video/src/assets/playlist_icon.svg'),
            minimiseIcon:require('@video/src/assets/minimiser.svg'),
            settingIcon:require('@video/src/assets/settings.svg')
        }
    },
    watch:{
        currentTime(newVal){
            if(!this.seekActive){
                this.progressTime=newVal;
            }
        }
    },
    computed:{
        progress(){
            return (this.progressTime * 100 /this.contentDuration);
        },
        bufferedPeriod(){
            return this.bufferedRange.map(pos=>(pos*100/this.contentDuration));
        },
        displayTime(){
            return getDuration(this.currentTime);
        },
        displayDuration(){
            return getDuration(this.contentDuration);
        },
        fsIcon(){
            return this.fsActive?this.fullscreenExitIcon:this.fullscreenEnterIcon;
        },
        fsEnabled(){
            return document.fullscreenEnabled;
        },
        volume(){
            return this.videoController.volume * 100;
        }
    },
    methods:{
        getPosition(){
            this.seekActive=false;
            let progress=this.$refs.progressBar?.getAttribute('progress');
            progress=Number(progress);
            if(isNaN(progress))return;
            let timeSeeked=parseInt( progress * this.contentDuration / 100,10);
            this.videoController.seekTrack(timeSeeked);
        },
        getSeek(e){
            this.seekActive=true;//hold attribute update while seeking
            this.showHover(e);
        },
        showHover(e){
            let progress=e.detail.position;
            if(isNaN(progress) || !isFinite(progress))return;
            this.seekPoint=progress;
            let seekTime=parseInt( progress * this.contentDuration / 100,10)
            this.displaySeek=getDuration(seekTime);   
        },
        updateVolume(e){
            let volume=e?.target.getAttribute('progress');
            volume=Number(volume);
            if(isNaN(volume))return;
            volume=volume/100;
            this.videoController.setVolume(()=>volume);
        }
    }
}
</script>
<style lang='scss'>
   figure:fullscreen #player-minimiser-feature{
       display:none;
   }
   .player-minimised .control-parent{
        min-height:40px !important;
        height: 15% !important;
        .controls{
            display:none !important;
        }
        .timings{
            display:none !important;
        }
        .progress-wrapper{
            height:40% !important;
        }
    } 
</style>
<style lang='scss' scoped>
@import '@video/src/scss/_mixins.scss';
@import '@video/src/scss/_breakpoints.scss';
@import '@video/src/scss/_variables.scss';
.control-parent{
    $icon-height:27%;
    $progress-bar-height:20%;
    position:absolute;
    bottom:0;
    left:50%;
    transform:translateX(-50%);
    height:$control-bar-height;
    width:$controls-width;
    .timings{
        position:absolute;
        @include flex($justify:space-between);
        height:max-content;
        width:100%;
        transform:translateY(-100%);
        color: rgba(255, 255, 255, 0.746);
        font-weight:bold;
        text-shadow:0 0 3px rgba(0,0,0,0.9);
    }
    .progress-wrapper{
        height:$progress-bar-height;
        width:100%;
        position:relative;
        .progress-slider{
                display:block;
                width:100%;
                height:100%;
            }
        .progress-slider:hover + .seeker{
            display:block;
        }    
        .seeker{
            position:absolute;
            bottom:100%;
            left:0;
            transform:translateX(-50%);
            color: rgba(255, 255, 255, 0.746);
            font-weight:bold;
            text-shadow:0 0 3px rgba(0,0,0,0.9);
            display:none;
        }
    }

    .controls{
        @include flex($justify:space-between);
        height:100% - $progress-bar-height;

        .left,.right{
            height:100%;
            flex:1;
        }
        .left{
            @include flex($justify:flex-start);
            .volume-wrapper{
                @include flex();
                width:160px;
                height: $icon-height;
                max-height:50%;
                overflow: hidden;
                .volume-icon{
                    height:100%;
                    max-height:100%;
                    position:relative;
                    z-index: 3;
                    cursor:pointer;
                }
                .volume-slider{
                     display: block;
                     height:50%;  
                     flex:1;
                     padding:0 10px;
                     box-sizing: border-box;
                     transition:transform 0.5s;
                     transform:translateX(-150%);
                }
                &:hover .volume-slider{
                    transform:translateX(0);
                }
                @include breakpoint(600){
                  width:max-content;
                  .volume-slider{
                    display:none;
                  }
                }
            }
        }

        .right{
            @include flex($justify:flex-end);
            .fs-wrapper,.playlist-wrapper,.settings-wrapper,.minimise-wrapper{
                max-height:50%;
                height:$icon-height;
                width:max-content;
                margin-left:3rem;
                @include breakpoint(600){
                    margin-left:2rem;
                    .minimise-button{
                        display:none;
                    }
                }
                button{
                    @include hovereffects;
                    border:0;
                    background:transparent;
                    padding:0;
                    height:100%;
                    display:block;
                    .fs-icon,.pl-icon,.st-icon,.m-icon{
                        height: 100%;
                        cursor:pointer;
                    }
                }
            }
            div:last-of-type{
                margin-right:0 !important;
            }
        }
    }
    
}
</style>